export function clearCaches() {
    console.log("Serviceworker: clear caches");

    if ("serviceWorker" in navigator) {
        caches.keys().then(function (cacheNames) {
            cacheNames.forEach(function (cacheName) {
                caches.delete(cacheName);
            });
        });
    }
}

export function register(swUrl, config) {
    console.log("Serviceworker: registerValidSW");

    if (!("serviceWorker" in navigator)) {
        console.log("Serviceworker: no service worker");
        return;
    }

    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            const waitingServiceWorker = registration.waiting;
            if (waitingServiceWorker) {
                //Don't think this will get hit
                console.log(`registerValidSW waiting > SKIP_WAITING`);
                waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
                waitingServiceWorker.addEventListener("statechange", (event) => {
                    console.log(`waitingServiceWorker stateChange > ${event.target.state}`);
                    if (event.target.state === "activated") {
                        window.location.reload();
                    }
                });
            }

            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    console.log(`Serviceworker: installingWorker is null`);
                    return;
                }
                installingWorker.onstatechange = () => {
                    console.log(`Serviceworker: installingWorker.onstatechange ${installingWorker.state}`);

                    if (installingWorker.state === "activated") {
                        window.location.reload();
                    }
                    if (installingWorker.state === "installed") {
                        console.log("registration  SKIP_WAITING");
                        installingWorker.postMessage({ type: "SKIP_WAITING" });

                        if (navigator.serviceWorker.controller) {
                            // At this point, the updated precached content has been fetched,
                            // but the previous service worker will still serve the older
                            // content until all client tabs are closed.
                            console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");

                            // Execute callback
                            if (config && config.onUpdate) {
                                config.onUpdate(registration);
                            }
                        } else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // "Content is cached for offline use." message.
                            console.log("Content is cached for offline use.");

                            // Execute callback
                            if (config && config.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        })
        .catch((error) => {
            console.error("Error during service worker registration:", error);
        });
}

export function unregister(config) {
    console.log("Serviceworker: entry");
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
            console.log("Serviceworker: unregister");
            registration.unregister().then((success) => {
                console.log(`Serviceworker: Unregistered success: ${success}`);
                if (config && config.onComplete) {
                    config.onComplete();
                }
            });
        });
    }
}
